import { routes } from "wasp/client/router";

/**
 * Scrolls smoothly to an anchor element on the page.
 * If not on the landing page, navigates to the landing page first, then scrolls.
 * @param anchorId - The ID of the element to scroll to (without the #)
 * @param navigate - Optional navigate function from react-router-dom
 */
export function scrollToAnchor(anchorId: string, navigate?: (path: string) => void) {
  const anchor = anchorId.replace("#", "");
  
  // Check if we're on the landing page
  const isOnLandingPage = window.location.pathname === "/";
  
  if (!isOnLandingPage && navigate) {
    // Navigate to landing page first, then scroll after a short delay
    navigate(`/#${anchor}`);
    setTimeout(() => {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  } else {
    // We're already on the landing page, just scroll
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}

/**
 * Handler for anchor link clicks that prevents default and scrolls smoothly
 */
export function handleAnchorClick(
  e: React.MouseEvent<HTMLAnchorElement>,
  anchorId: string,
  navigate?: (path: string) => void
) {
  e.preventDefault();
  scrollToAnchor(anchorId, navigate);
}

